import React from "react";
import {
  Card,
  Box,
  Tabs,
  Tab,
  CardContent,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PeopleIcon from "@mui/icons-material/People";
import LawFirmLocationsTabPanel from "./LawFirmLocationsTabPanel";
import LawFirmUsersTabPanel from "./LawFirmUsersTabPanel";

function LawFirmDetailsTabbedCard({
  tabValue,
  handleTabChange,
  filteredLocations,
  locations,
  locationSearchQuery,
  filteredTeamMembers,
  teamMembers,
  userSearchQuery,
  locationsTabProps,
  usersTabProps,
}) {
  return (
    <Grid size={{ xs: 12 }}>
      <Card elevation={3} sx={{ borderRadius: "16px" }}>
        {/* Tab Headers */}
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "1.1rem",
                fontWeight: "600",
                minHeight: "64px",
                color: "#1976d2", // Blue text
                "&.Mui-selected": {
                  backgroundColor: "white",
                  borderBottom: "3px solid #1976d2",
                  color: "#1976d2",
                },
                "&:hover": {
                  backgroundColor: "#bbdefb",
                },
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#1976d2",
                height: "3px",
              },
            }}
          >
            <Tab
              icon={<LocationOnIcon />}
              iconPosition="start"
              label={`Locations (${filteredLocations.length}${
                locationSearchQuery ? ` of ${locations.length}` : ""
              })`}
            />
            <Tab
              icon={<PeopleIcon />}
              iconPosition="start"
              label={`Law Firm Users (${filteredTeamMembers.length}${
                userSearchQuery ? ` of ${teamMembers.length}` : ""
              })`}
            />
          </Tabs>
        </Box>

        {/* Tab Content */}
        <CardContent sx={{ padding: 0 }}>
          {tabValue === 0 && (
            <LawFirmLocationsTabPanel {...locationsTabProps} />
          )}
          {tabValue === 1 && <LawFirmUsersTabPanel {...usersTabProps} />}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default LawFirmDetailsTabbedCard;
